import { useState } from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default function EmailChipInput({
  value = [],
  onChange,
  error,
  label,
  required,
}) {
  const [input, setInput] = useState("");

  const addEmail = (email) => {
    if (!EMAIL_REGEX.test(email)) return;

    if (!value.includes(email)) {
      onChange([...value, email]);
    }
  };

  const commitEmail = () => {
    const email = input.trim();
    if (email) addEmail(email);
    setInput("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "," || e.key === "Enter") {
      e.preventDefault();
      commitEmail();
    }
  };

  const removeEmail = (email) => {
    onChange(value.filter((e) => e !== email));
  };

  return (
    <div>
      <label className="block mb-1">
        {label} {required ? <span className="text-red-500">*</span> : null}
      </label>

      {/* Scrollable container */}
      <div
        className="
          flex flex-wrap gap-2 border rounded px-2 py-1
          max-h-15 overflow-y-auto
        "
      >
        {value.map((email) => (
          <span
            key={email}
            className="flex items-center bg-gray-200 rounded-full px-2 py-1 text-sm"
          >
            {email}
            <button
              type="button"
              className="ml-2 text-red-600"
              onClick={() => removeEmail(email)}
            >
              ✕
            </button>
          </span>
        ))}

        <input
          className="flex-1 min-w-[120px] outline-none bg-transparent"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          onBlur={commitEmail}
          placeholder="Enter email and press comma"
        />
      </div>

      {error ? (
        <span className="text-red-500 text-sm mt-1 block">{error}</span>
      ) : null}
    </div>
  );
}
